import { render, staticRenderFns } from "./IconArrowDouble.vue?vue&type=template&id=5a3cc7a4&scoped=true&"
import script from "./IconArrowDouble.vue?vue&type=script&lang=js&"
export * from "./IconArrowDouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3cc7a4",
  null
  
)

export default component.exports